module.exports = "/_next/static/resources/box-83802cb305c6fcbe480d2122061db920.jpg";